<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="待发货" style="height:auto" >
      <el-form :inline="true" :model="order" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input size="mini" v-model.trim="order.orderNo" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item label="产品型号">
          <el-input size="mini" v-model.trim="order.manufacturerNumber" placeholder="产品型号"></el-input>
        </el-form-item>
        <el-form-item label="登录用户名">
          <el-input size="mini" v-model.trim="order.moblie" placeholder="登录用户名"></el-input>
        </el-form-item>
        <el-form-item label="关联订单">
          <el-checkbox v-model="order.isBelong"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="data"
        size="small"
        :row-key="getRowKeysMain"
        :expand-row-keys="expandsMain"
        @expand-change="openExpandMain"
        border>
        <el-table-column 
          type="expand" Scoped slot>
          <template slot-scope="props">
            <el-tabs v-model="activeName" @tab-click="handleClick" style="width:100%">
              <el-tab-pane label="订单详情" name="first">
                <el-table :data="props.row.childList" border style="height:100%;"
                :row-key="getRowKeys"
                :expand-row-keys="expands"
                @expand-change="openExpand">
                  <el-table-column
                    fixed
                    type="expand" Scoped slot>
                    <template slot-scope="props">
                      <el-tabs v-model="activeName" style="width:70%">
                        <el-tab-pane label="物流详情" name="first">
                          <el-table :data="props.row.trackChildList" border style="height:100%;"
                          :row-class-name="tableRowClassName"
                          @cell-dblclick="trackTabClick">
                            <el-table-column prop="trackNo" label="物流编号"
                              width="260"
                              show-overflow-tooltip>
                              <template scope="scope" >
                                <span v-if="scope.row.index === cellTrack.tabMainIndex && cellTrack.tabMainLabel === '物流编号'">
                                  <el-input size="small"
                                  v-model="cellTrack.trackNo" placeholder="请输入内容" @blur="handleTrackNoEdit(scope.row)"/>
                                </span>
                                <template v-else>
                                  <span>{{scope.row.trackNo}}</span>
                                </template>
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="物流公司"
                              width="100">
                              <template slot-scope="scope">
                                <span v-if="scope.row.trackCompanyId == 1">顺丰</span>
                                <span v-if="scope.row.trackCompanyId == 2">中通</span>
                                <span v-if="scope.row.trackCompanyId == 3">圆通</span>
                                <span v-if="scope.row.trackCompanyId == 4">汇通快递</span>
                                <span v-if="scope.row.trackCompanyId == 5">申通</span>
                                <span v-if="scope.row.trackCompanyId == 6">韵达</span>
                                <span v-if="scope.row.trackCompanyId == 7">EMS</span>
                                <span v-if="scope.row.trackCompanyId == 8">京东</span>
                                <span v-if="scope.row.trackCompanyId == 8">宅急送</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="trackPhone"
                              label="联系电话"
                              width="130">
                            </el-table-column>
                            <el-table-column
                              prop="createDate"
                              width="180"
                              label="创建时间">
                            </el-table-column>
                            <el-table-column
                              label="操作">
                              <template slot-scope="scope">
                                <el-button
                                  size="mini"
                                  @click="queryTrack(scope.row)">查看物流</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                        </el-tab-pane>
                      </el-tabs>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="orderNo"
                    label="子订单编号"
                    width="210">
                  </el-table-column>
                  <el-table-column
                    prop="manufacturerNumber"
                    show-overflow-tooltip
                    label="产品型号"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    show-overflow-tooltip
                    label="品牌"
                    width="110">
                  </el-table-column>
                  <el-table-column
                    prop="originalPrice"
                    label="商品原价"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="discountedPrice"
                    label="购买价格"
                    width="100">
                  </el-table-column>
                  <el-table-column 
                    prop="costPrice" 
                    label="成本价"
                    width="100"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="count"
                    label="购买数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="sendCount"
                    label="发货数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="attachAmount"
                    label="附加费"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="preferentialMargins"
                    label="总优惠"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="70">
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderStatus == -4" style="color:#989998">支付失败</span>
                      <span v-if="scope.row.orderStatus == -3" style="color:#989998">已退款</span>
                      <span v-if="scope.row.orderStatus == -2" style="color:#989998">退款申请</span>
                      <span v-if="scope.row.orderStatus == -1" style="color:#989998">已取消</span>
                      <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C">待确认</span>
                      <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C">待付款</span>
                      <span v-if="scope.row.orderStatus == 2" style="color:#E6A23C">部分付款</span>
                      <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C">预付订单</span>
                      <span v-if="scope.row.orderStatus == 3" style="color:#E6A23C">支付成功</span>
                      <span v-if="scope.row.orderStatus == 4" style="color:#67C23A">待发货</span>
                      <span v-if="scope.row.orderStatus == 41" style="color:#E6A23C">未付审批</span>
                      <span v-if="scope.row.orderStatus == 5" style="color:#67C23A">发货中</span>
                      <span v-if="scope.row.orderStatus == 6" style="color:#409EFF">已发货</span>
                      <span v-if="scope.row.orderStatus == 61" style="color:#409EFF">未付发货</span>
                      <span v-if="scope.row.orderStatus == 7" style="color:#989998">已完成</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="totalAmount"
                    label="总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="originalAmount"
                    label="需付金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    show-overflow-tooltip
                    label="备注">
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-popconfirm
                        size="mini"
                        v-if="scope.row.orderStatus == 4 && scope.row.count != scope.row.sendCount"
                        @confirm="refundPartMoney(scope.row)"
                        title="是否退还剩下部分未发货的金额？">
                        <el-button slot="reference"
                        type="danger"
                        size="mini">部分退还</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="交易记录" name="third">
                <el-table
                  :data="props.row.payRecordList"
                  style="height:100%;"
                  border>
                  <el-table-column
                    fixed
                    prop="mainOrderNo"
                    label="支付编号"
                    width="220"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="outPayNo"
                    label="第三方支付编号"
                    width="220"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payType"
                    :formatter="formatPayType"
                    show-overflow-tooltip
                    label="支付类型"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="payStatus"
                    label="状态"
                    width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.payStatus == 1" style="color:#F56C6C">待处理</span>
                      <span v-if="scope.row.payStatus == 2" style="color:#67C23A">已完成</span>
                      <span v-if="scope.row.payStatus == 4" style="color:#F56C6C">预付订单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="payMethod"
                    :formatter="formatPay"
                    label="付款方式"
                    width="100"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payAmount"
                    label="预付金额"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="realAmount"
                    label="已付金额"
                    width="120"
                    >
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="payTime"
                    label="付款时间"
                    width="200"
                    >
                  </el-table-column>
                  <el-table-column
                    label="操作" >
                    <template slot-scope="scope">
                      <el-popconfirm
                        size="mini"
                        v-if="scope.row.payStatus == 2 && scope.row.realAmount > 0"
                        @confirm="refundModifyOrder(scope.row)"
                        title="确定要取消这条记录吗？">
                        <el-button slot="reference"
                        type="danger"
                        size="mini">退款</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="收货信息" name="second">
                <el-table
                  :data="props.row.userAddressPo"
                  border
                  style="width: 75%">
                  <el-table-column
                    prop="province"
                    show-overflow-tooltip
                    width="120"
                    label="所属省份">
                  </el-table-column>
                  <el-table-column
                    prop="city"
                    show-overflow-tooltip
                    width="120"
                    label="所属市区">
                  </el-table-column>
                  <el-table-column
                    prop="area"
                    show-overflow-tooltip
                    width="120"
                    label="所属地区">
                  </el-table-column>
                  <el-table-column
                    prop="addressDetail"
                    show-overflow-tooltip
                    label="详细地址">
                  </el-table-column>
                  <el-table-column
                    prop="consignee"
                    show-overflow-tooltip
                    width="120"
                    label="联系人">
                  </el-table-column>
                  <el-table-column
                    prop="mobile"
                    show-overflow-tooltip
                    label="联系方式"
                    width="120">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="发票信息" name="fourth">
                <template v-if="props.row.userInvoiceResponseVo">
                  <el-form>
                    <el-form-item label="发票类型" :label-width="formLabelWidth">
                    <el-select v-model="props.row.userInvoiceResponseVo.type" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="发票抬头" :label-width="formLabelWidth"> 
                      <el-input v-model="props.row.userInvoiceResponseVo.companyName"  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记号" :label-width="formLabelWidth">
                      <el-input v-model="props.row.userInvoiceResponseVo.invoiceNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司注册地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.companyAddress" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司电话" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.companyMobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.bankName" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行账号" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.bankNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="收票人" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.consignee" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="收票地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.addressDetail" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.mobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电子版盖章开票信息" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-image :src="props.row.userInvoiceResponseVo.invoiceFile" ></el-image>
                    </el-form-item>
                  </el-form>
                </template>
                <template v-else>
                  <div style="padding: 10px 0 20px 0; width: 60%; text-align:center;">
                    暂无
                  </div>
                </template>
              </el-tab-pane>
              <el-tab-pane label="合同记录" name="five">
                <template v-if="props.row.contractRecordList">
                  <el-table
                    :data="props.row.contractRecordList"
                    border
                    style="width: 75%">
                    <el-table-column
                      prop="contractNo"
                      show-overflow-tooltip
                      label="合同编号">
                    </el-table-column>
                    <el-table-column
                      prop="consignee"
                      show-overflow-tooltip
                      label="合同下载">
                      <template slot-scope="scope">
                        <a target="_blank" :href="scope.row.contractPath">查看</a>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="createDate"
                      show-overflow-tooltip
                      label="合同时间">
                    </el-table-column>
                  </el-table>
                </template>
                <template v-else>
                  <div v-if="(props.row.orderStatus != 7 || props.row.orderStatus != 8) 
                      && props.row.invoiceId && props.row.userInvoiceResponseVo && props.row.userInvoiceResponseVo.type == 2"  
                      class="invoice-css">
                    <el-button
                      size="mini"
                      @click="createContract(props.row)">合同</el-button>
                  </div>
                  <div class="invoice-css" v-else>
                    当前数据无法生成合同
                  </div>
                </template>
              </el-tab-pane>
              <el-tab-pane label="发货清单" name="sex">
                <template v-if="props.row.deliveryGoodsList">
                  <el-table
                    :data="props.row.deliveryGoodsList"
                    border
                    style="width: 75%">
                    <el-table-column
                      prop="sendsNo"
                      show-overflow-tooltip
                      label="清单编号">
                    </el-table-column>
                    <el-table-column
                      prop="goodsOrderPath"
                      show-overflow-tooltip
                      label="清单下载">
                      <template slot-scope="scope">
                        <a target="_blank" :href="scope.row.goodsOrderPath">查看</a>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="createDate"
                      show-overflow-tooltip
                      label="清单时间">
                    </el-table-column>
                  </el-table>
                </template>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="订单编号"
          show-overflow-tooltip
          width="170">
        </el-table-column>
        <el-table-column
          prop="createDate"
          show-overflow-tooltip
          label="下单时间"
          width="160">
        </el-table-column>
        <el-table-column
          label="用户名"
          show-overflow-tooltip
          width="260">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.orderStatus != -1 && scope.row.orderStatus != -3"
              placement="top"
              title="收货信息"
              trigger="click">
              <p>登录名: {{ scope.row.userName }}</p>
              <p>收货人: {{ scope.row.receiveUser }}</p>
              <p>联系方式: {{ scope.row.receiveMobile }}</p>
              <p>收货地址: {{ scope.row.receiveAddress }}</p>
              <el-button type="text" slot="reference">{{ scope.row.userName }}</el-button>
            </el-popover>
            <span v-else>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="originalAmount"
          label="商品原价"
          width="100">
        </el-table-column>
        <el-table-column
          prop="transportAmount"
          label="运费金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="attachAmount"
          label="附加费"
          width="120">
        </el-table-column>
        <el-table-column
          prop="orderStatus"
          label="状态"
          width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus == -4" style="color:#989998">支付失败</span>
            <span v-if="scope.row.orderStatus == -3" style="color:#989998">已退款</span>
            <span v-if="scope.row.orderStatus == -2" style="color:#989998">退款申请</span>
            <span v-if="scope.row.orderStatus == -1" style="color:#989998">已取消</span>
            <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C">待确认</span>
            <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C">待付款</span>
            <span v-if="scope.row.orderStatus == 2" style="color:#E6A23C">部分付款</span>
            <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C">预付订单</span>
            <span v-if="scope.row.orderStatus == 3" style="color:#E6A23C">支付成功</span>
            <span v-if="scope.row.orderStatus == 4" style="color:#67C23A">待发货</span>
            <span v-if="scope.row.orderStatus == 41" style="color:#E6A23C">未付审批</span>
            <span v-if="scope.row.orderStatus == 5" style="color:#67C23A">发货中</span>
            <span v-if="scope.row.orderStatus == 6" style="color:#409EFF">已发货</span>
            <span v-if="scope.row.orderStatus == 61" style="color:#409EFF">未付发货</span>
            <span v-if="scope.row.orderStatus == 7" style="color:#989998">已完成</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="总金额"
          width="120">
        </el-table-column>
        <el-table-column
          prop="payAmount"
          label="实收款"
          width="120">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button
              size="mini"
              @click="sendGoodsList(scope.row)">发货清单</el-button>
            </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
    <el-dialog title="物流信息" :visible.sync="dialogOrderFormVisible" width="780px">
      <el-table :data="trackDataList" border style="height:100%;">
        <el-table-column
          prop="ftime"
          label="时间"
          width="210">
        </el-table-column>
        <el-table-column
          prop="context"
          label="物流轨迹">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
   </el-tabs>
</template>
<script>
import pagination from "../../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      expands: [],
      expandsMain: [],
      trackList: [],
      trackDataList: [],
      formLabelWidth: '140px',
      dialogFormVisible:false,
      dialogOrderFormVisible: false,
      activeName: 'first',
      addressList: [],
      cellTrack: {
        tabMainIndex : '',
        tabMainLabel : '',
        trackNo: ''
      },
      getRowKeys: (row) => {
        return row.orderNo   
      },
      getRowKeysMain: (row) => {
        return row.orderNo   
      },
      payList:[],
      sendForm: {
        trackNo: '',
        companyId: 11,
        orderNo: '',
        orderNos: '',
        token: this.user.getToken()
      },
      order: {
        payType: '',
        orderNo: '',
        isBelong: false,
        orderStatus:'4',
        token: this.user.getToken()
      },
      trackForm: {
        subOrderNo: '',
        token: this.user.getToken()
      },
      contract: {
        orderNo: '',
        token: this.user.getToken()
      },
      modifyOrderForm: {
        orderNo: '',
        tno: '',
        tcId: 1,
        token: this.user.getToken()
      },
      invoiceParam: {
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      companyAll: {
        data: []
      },
      orderNos: '',
      options: [{
          value: 1,
          label: '普通发票'
        }, {
          value: 2,
          label: '专用发票'
        }, {
          value: 3,
          label: '个人'
        }]
    };
  },
  components: {
    pagination
  },
  methods: {
    trackTabClick: function(row, column, cell, event) {
      this.cellTrack.tabMainIndex = row.index
      this.cellTrack.tabMainLabel = column.label
      this.cellTrack.trackNo = row.trackNo
    },
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex
    },
    // 退款申请
    refundModifyOrder: function(row) {
      // 判断该订单下是否存在需要发货的字订单
      this.http.post(
      '/order/refund/apply', 
      {
        supplementNo: row.supplementNo,
        payType: row.payType,
        token: this.user.getToken()
      }, res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    },
    createContract: function(rows) {
      this.contract.orderNo = rows.orderNo
      // 初始化默认加载菜单
      this.http.post(
        '/contract/create',
        this.contract,
        res => {
          if (res.success) {
            this.getOrderData()
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    sendGoodsList: function(rows) {
      // 判断该订单下是否存在需要发货的字订单
      this.$prompt('是否确认打印清单请填写物流单号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.http.post(
            '/offline/order/inventory/goods',
            {
              orderNo: rows.orderNo,
              trackNo: value,
              token: this.user.getToken()
            }, res => {
              if (res.success) {
                // 返回正确的处理
                this.getOrderData();
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
      });
    },
    openExpand: function(row, rowList) {
      let _this = this
      // var that = this
      if (rowList.length) { // 只展开一行//说明展开了
        _this.expands = []
        if (row) {
          _this.expands.push(row.orderNo)// 只展开当前行id
        }
      //  this.tablaData(row.eqId)  这里可以调用接口数据渲染
      } else { // 说明收起了
        _this.expands = []
      }
      _this.activeName = 'first'
      _this.loading = true
    },
    openExpandMain: function(row, rowList) {
      let _this = this
      // var that = this
      if (rowList.length) { // 只展开一行//说明展开了
        _this.expandsMain = []
        if (row) {
          _this.expandsMain.push(row.orderNo)// 只展开当前行id
        }
      //  this.tablaData(row.eqId)  这里可以调用接口数据渲染
      } else { // 说明收起了
        _this.expandsMain = []
      }
      _this.activeName = 'first'
      _this.loading = true
    },
    handleClick(sval) {
      if (this.activeName =='six') {
        this.historyOrder.userId = sval.userId
        this.getHistoryOrderData()
      }
    },
    handleTrackNoEdit: function(row) {
      if (this.cellTrack.trackNo != row.trackNo) {
          this.modifyOrderForm.orderNo = row.subOrderNo
          this.modifyOrderForm.companyId = row.trackCompanyId
          this.modifyOrderForm.trackNo = this.cellTrack.trackNo
          this.http.post(
            '/offline/track/modifyTruckNo',
            this.modifyOrderForm,
            res => {
              if (res.success) {
                row.trackNo = this.cellTrack.trackNo 
                this.cellTrack.tabMainIndex = null
                this.cellTrack.tabMainLabel = '' 
                this.cellTrack.trackNo = ''
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
            }
          );
      }else {
        this.cellTrack.tabMainIndex = null
        this.cellTrack.tabMainLabel = '' 
        this.cellTrack.trackNo = ''
      }
    },
    refundPartMoney: function(row) {
      // 判断该订单下是否存在需要发货的字订单
      this.http.post(
      '/order/partApply', 
      {
        orderNo: row.mainOrderNo,
        subOrderNo: row.orderNo,
        payType: row.payType,
        token: this.user.getToken()
      }, res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    },
    getExpressCompanyList: function() {
      this.optionItem = this.common.extend(this.companyForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/expressCompany/list',
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.companyAll.data = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    handleSelectionChange: function(rows) {
      this.orderNos = ''
      rows.forEach((item) => {
        this.orderNos += item.orderNo + ','
      })
    },
    formatPay: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "微信";
      } else if (cellValue === 2) {
        return "支付宝";
      } else if (cellValue === 3) {
        return "对公付款";
      }
    },
    formatPayType: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "付款";
      } else if (cellValue === 2) {
        return "附加费";
      } else if (cellValue === 3) {
        return "退款";
      } else if (cellValue === 4) {
        return "部分退还";
      } else if (cellValue === 5) {
        return "优惠退还";
      }
    },
    formatPayStatus: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未付款";
      } else if (cellValue === 2) {
        return "已付款";
      } else if (cellValue === 3) {
        return "失败";
      } else if (cellValue === 4) {
        return "部分付款";
      }
    },
    formatInvoice: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未开票";
      } else if (cellValue === 2) {
        return "已开票";
      } else if (cellValue === 3) {
        return "不需要";
      }
    },
    formatStockState: function(row, column, cellValue) {
      if (cellValue === 0) {
        return "digikey";
      } else if (cellValue === 10) {
        return "京北通宇";
      } else if (cellValue === 8) {
        return "国内现货";
      } else if (cellValue === 4) {
        return "云汉商城";
      } else if (cellValue === 5) {
        return "华强商城";
      } else if (cellValue === 6) {
        return "维样商城";
      } else if(cellValue === 2) {
        return "自营库存";
      } else if(cellValue === -1) {
        return "mouser";
      } else if(cellValue === -2) {
        return "arrow";
      } else if(cellValue === 11) {
        return "圣禾堂";
      } else if(cellValue === 3) {
        return "立创商城";
      }else{
        return "其他";
      }
    },
    getOrderData: function() {
      this.optionItem = this.common.extend(this.order, this.pagination);
      // 初始化默认加载菜单
      this.http.post(
        '/offline/order/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    queryTrack: function(row) {
      this.dialogOrderFormVisible = true
      this.modifyOrderForm.tno = row.trackNo
      this.modifyOrderForm.tcId = row.trackCompanyId
      this.modifyOrderForm.phone = row.trackPhone
      this.http.post(
        '/offline/track/query',
        this.modifyOrderForm,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.trackDataList = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getOrderData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getOrderData()
    },
  },
  mounted: function() {
    this.getOrderData();
  },
};
</script>


<style>
.invoice-css {
  padding: 10px 0 20px 0; width: 60%; text-align:center;
}
.el-table th {
  background: #F5F7FA;
}
.el-table__expanded-cell {  
  padding: 0px 0px 15px 47px !important;
}
.el-tabs {
  border:1px solid #eee;
}
.el-tabs__nav {
  padding: 0 20px;
}
.el-tabs__active-bar {
  margin-left: 20px;
}
.el-input--suffix .el-input__inner {
  padding-right: 16px;
}

.demo-table-expand {
  font-size: 0;
}
.el-form-item__content {
  line-height: none;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.el-table .success-refund{
  background: #FFF;
}
.el-table .success-paid{
  background:#FFF;
}

.el-table .success-over {
  background: #f5f7fa;
}
</style>


// WEBPACK FOOTER //
// src/components/views/order/offline/orderCompleteList.vue